import { render, staticRenderFns } from "./BulkProductGridContainer.vue?vue&type=template&id=466d5906&"
import script from "./BulkProductGridContainer.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports